import Button from "../button";
import styles from "./index.module.css";
const BuyCard = () => {
  return (
    <div className={styles.ctn}>
    <div></div>
      <div>
        <div className={styles.textBox}>
          <h5>Tell Better Stories</h5>
          <h2>SMOOTH 5S</h2>
        </div>
        <Button className={styles.buyButton} href="https://www.zhiyun-tech.com/en/product/detail/684">
          Learn More
          <svg
            width="19"
            height="9"
            viewBox="0 0 19 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 4.5H18M18 4.5L14 0.5M18 4.5L14 8.5" stroke="white" />
          </svg>
        </Button>
      </div>
    </div>
  );
};

export default BuyCard;
